
import { HTMLAttributes } from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-md",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/90",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "text-foreground border-border hover:bg-accent hover:text-accent-foreground",
        success:
          "border-transparent bg-emerald-100 text-emerald-700 hover:bg-emerald-200 px-2.5 py-1 text-xs font-medium rounded-lg border border-emerald-200",
        info:
          "border-transparent bg-sky-100 text-sky-700 hover:bg-sky-200 px-2.5 py-1 text-xs font-medium rounded-lg border border-sky-200",
        warning:
          "border-transparent bg-orange-100 text-orange-700 hover:bg-orange-200 px-2.5 py-1 text-xs font-medium rounded-lg border border-orange-200",
        accent:
          "border-transparent bg-marine-100 text-marine-700 hover:bg-marine-200 px-2.5 py-1 text-xs font-medium rounded-lg border border-marine-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
